export default "__VITE_ASSET__D1Wc71Gc__"